module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container login-erea"
  }, [_c('el-form', {
    ref: "loginForm",
    staticClass: "card-box login-form",
    attrs: {
      "autoComplete": "on",
      "model": _vm.loginForm,
      "rules": _vm.loginRules,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("音像电子出版单位年度核验管理系统")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "prefix-icon": "el-icon-edit",
      "name": "mobilePhone",
      "type": "text",
      "autoComplete": "off",
      "placeholder": "单位名称"
    },
    model: {
      value: (_vm.loginForm.account),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "account", $$v)
      },
      expression: "loginForm.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "pwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.typePwd,
      "prefix-icon": "el-icon-edit",
      "name": "password",
      "autoComplete": "off",
      "placeholder": "密码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.handleLogin($event)
      }
    },
    model: {
      value: (_vm.loginForm.pwd),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "pwd", $$v)
      },
      expression: "loginForm.pwd"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "30px",
      "height": "30px",
      "top": "5px",
      "right": "5px",
      "cursor": "pointer"
    },
    attrs: {
      "src": _vm.imgPwd,
      "alt": "密码",
      "hidden": !_vm.imgPwdShow
    },
    on: {
      "click": function($event) {
        _vm.showPwd()
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "imgCode"
    }
  }, [_c('el-input', {
    staticClass: "imgCode",
    attrs: {
      "autoComplete": "off",
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.loginForm.imgCode),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "imgCode", $$v)
      },
      expression: "loginForm.imgCode"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgbox"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl
    },
    on: {
      "click": _vm.imgChange
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "login-bx"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleLogin
    }
  }, [_vm._v(" 登录 ")])], 1), _vm._v(" "), (_vm.isShowChromeTip) ? _c('div', {
    staticStyle: {
      "color": "red",
      "font-size": "15px",
      "text-align": "center"
    }
  }, [_vm._v("\n      请务必使用360浏览器极速模式打开【"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://down.360safe.com/se/360se10.0.1250.0.exe"
    }
  }, [_vm._v("点击下载")]), _vm._v("】\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "login-tip"
  }, [_vm._v("\n      工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2ff4004"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/login.vue
// module id = 1793
// module chunks = 1